/**
 * F7 — what a NEW Income or Expense must carry (owner's decision 2026-09-25):
 * a remark, and — when the chosen category has live sub-categories — one of
 * those sub-categories rather than the parent. Transfers are exempt, and so
 * is editing an entry that already exists.
 *
 * Shared by the web and Android entry screens; the server enforces the same
 * rule (`app/services/entry_rules.py`) as the backstop.
 */
export interface EntryCategory {
  id: string;
  name: string;
  parentId?: string | null;
  isArchived?: boolean;
}

export interface EntryProblem {
  field: "description" | "categoryId";
  message: string;
}

export function newEntryProblem(
  entry: { type: "income" | "expense" | "transfer"; categoryId?: string | null; remark?: string | null },
  categories: readonly EntryCategory[],
): EntryProblem | null {
  if (entry.type === "transfer") return null;
  if (entry.categoryId) {
    const hasLiveChildren = categories.some(
      (c) => c.parentId === entry.categoryId && !c.isArchived,
    );
    if (hasLiveChildren) {
      const parent = categories.find((c) => c.id === entry.categoryId);
      return {
        field: "categoryId",
        message: `Pick a sub-category of ${parent?.name ?? "this category"}.`,
      };
    }
  }
  if (!(entry.remark ?? "").trim()) {
    return { field: "description", message: "Add a remark — every new entry needs one." };
  }
  return null;
}
